import React, { Component } from "react";
import { Transition } from "react-transition-group";

const sloganDisplayDuration = 5000; //ms
const transitionDuration = 1300; //ms

class AnimatedSlogan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSlogan: 0,
      displaySlogan: false,
      transitionTimeoutId: null,
      displayTimeoutId: null
    };
    this.makeSloganAppear = this.makeSloganAppear.bind(this);
    this.changeSlogan = this.changeSlogan.bind(this);
  }

  //init state, change slogan after sloganDisplayDuration
  componentDidMount() {
    this.setState({
      displaySlogan: true,
      displayTimeoutId: setTimeout(this.changeSlogan, sloganDisplayDuration)
    });
  }

  //make slogan disappear and make slogan appear after transitionDuration
  changeSlogan() {
    //make slogan disappear & call makeSloganAppear after transitionDuration
    this.setState({
      displaySlogan: false,
      displayTimeoutId: setTimeout(this.makeSloganAppear, transitionDuration)
    });
  }

  makeSloganAppear() {
    this.setState({
      displaySlogan: true,
      currentSlogan: (this.state.currentSlogan + 1) % this.props.slogans.length,
      displayTimeoutId: setTimeout(this.changeSlogan, sloganDisplayDuration)
    });
  }

  componentWillUnmount() {
    this.state.transitionTimeoutId &&
      clearTimeout(this.state.transitionTimeoutId);
    this.state.displayTimeoutId && clearTimeout(this.state.displayTimeoutId);
  }
  render() {
    return (
      <div className="text-center">
        <Transition in={this.state.displaySlogan} timeout={transitionDuration}>
          {transitionState => {
            const transition =
              transitionState === "entering"
                ? "animated fadeIn"
                : transitionState === "exiting"
                ? "animated fadeOut"
                : "";
            return (
              <p
                className={
                  "inline-block p-4 bg-white-75 rounded-lg text-red-darkest text-xl italic font-serif " +
                  transition
                }>
                {this.props.slogans[this.state.currentSlogan]}
              </p>
            );
          }}
        </Transition>
      </div>
    );
  }
}

export default AnimatedSlogan;
/*          */
